import { Routes } from '@angular/router';
import { GlobalComplianceComponent } from './features/global-compliance/global-compliance.component';
import { UserGuardWithRole } from './shared/guards/user.guard';
import { DataAuthorizationGuard } from './shared/guards/data-authorization.guard';
import { TaDetailComponent } from './features/ta-detail/ta-detail.component';
import { UnauthorizedComponent } from './shared/components/unauthorized/unauthorized.component';
import { DashboardComponent } from './core/layout/pages/dashboard/dashboard.component';
import { BlankLayoutComponent } from './core/layout/pages/blank-layout/blank-layout.component';
import { AdminComponent } from './features/admin/admin.component';
import { UserRole } from './core/auth/models/profile';
import { CompareComponent } from './features/compare/compare.component';
import { NoRegionsComponent } from './shared/components/unauthorized/no-regions/no-regions.component';

export const routes: Routes = [
  // Routes WITH dashboard layout (toolbar, sidebar, footer)
  {
    path: '',
    component: DashboardComponent,
    canActivate: [UserGuardWithRole([UserRole.ANY])],
    children: [
      {
        path: '',
        component: GlobalComplianceComponent,
        title: 'Global Compliance - Cerberus',
      },
      {
        path: 'details',
        children: [
          {
            path: ':ta',
            redirectTo: ':ta/',
            pathMatch: 'full',
          },
          {
            path: ':ta/:element',
            redirectTo: ':ta/:element/',
            pathMatch: 'full',
          },
          {
            path: ':ta/:element',
            component: TaDetailComponent,
            title: 'Therapeutic Area Detail - Cerberus',
            canActivate: [DataAuthorizationGuard],
          },
          {
            path: ':ta/:element/:flag',
            component: TaDetailComponent,
            title: 'Therapeutic Area Detail - Cerberus',
            canActivate: [DataAuthorizationGuard],
          },
          {
            path: ':ta/:element/compare/:type/:element1/:element2',
            component: CompareComponent,
            title: 'Compare - Cerberus',
          },
        ],
      },
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [UserGuardWithRole([UserRole.ADMIN])],
      },
    ],
  },
  // Routes WITHOUT dashboard layout (blank/minimal)
  {
    path: '',
    component: BlankLayoutComponent,
    children: [
      {
        path: 'unauthorized',
        title: 'Unauthorized - Cerberus',
        component: UnauthorizedComponent,
      },
      {
        path: 'no-regions',
        title: 'Unauthorized - Cerberus',
        component: NoRegionsComponent,
      },
    ],
  },
];
